import { CoreOperation } from "../../core/index.js";
export class PimCreate extends CoreOperation {
    /**
     * IRI of the newly created object.
     */
    pimNewIri = null;
    pimInterpretation = null;
    pimTechnicalLabel = null;
    pimHumanLabel = null;
    pimHumanDescription = null;
    constructor() {
        super();
    }
}
//# sourceMappingURL=pim-create.js.map